import { z } from 'zod'

export const uuid = z.string().uuid()

// Indian mobile numbers as written on the form. Kept permissive on purpose:
// rejecting a real patient's number at the counter is worse than storing an
// unusual one, and this is not a field we dial programmatically.
export const phone = z
  .string()
  .trim()
  .regex(/^[0-9+\-\s()]{6,20}$/, 'Enter a valid phone number')

export const nonEmpty = (max: number) => z.string().trim().min(1).max(max)
export const optionalText = (max: number) =>
  z.string().trim().max(max).optional().nullable().transform(v => (v ? v : null))

// Cursor pagination, not offset. OFFSET re-scans every skipped row, so page
// 500 costs 500 pages of work; a keyset cursor costs the same as page 1 and
// cannot skip or repeat rows when data changes underneath.
export const pageQuery = z.object({
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
  q: z.string().trim().max(120).optional(),
})
export type PageQuery = z.infer<typeof pageQuery>

// Every mutation carries the id the CLIENT generated. A retry after a lost
// response replays the same id, so the write is idempotent instead of
// creating a duplicate patient in a statutory register.
export const withClientId = z.object({ id: uuid })
